/**
 * UnknownWidget.jsx — fallback renderer for widget types that don't yet
 * have a frontend component registered. Shipped so users get a friendly
 * message + a remove button instead of a bare "No renderer for X" line
 * (and so future widget types added on the backend never strand users).
 */
import wm from '../lib/wmStore.js';
import { toast } from '../lib/toastStore.js';

export default function UnknownWidget(props) {
  const type = () => props.widget?.widget_type ?? 'unknown';

  function remove() {
    try {
      wm.closeWidget(props.widget.id);
      toast?.info?.(`Removed "${type()}" widget`);
    } catch (e) {
      console.error('[unknown-widget] remove failed', e);
    }
  }

  return (
    <div class="v2-unknown-widget">
      <div class="v2-unknown-widget__icon">⚠️</div>
      <h4>No renderer for <code>{type()}</code></h4>
      <p>
        This widget type is registered on the server but the frontend
        bundle doesn't ship a renderer yet. The next deploy should
        include it.
      </p>
      <button type="button" class="v2-unknown-widget__remove" onClick={remove}>
        Remove this widget
      </button>
    </div>
  );
}
